import router from 'next/router'

export const redirect = (url: string) => {
  router.push(url)
}
